// Shared helpers for the 'HH:mm:ss' string format used throughout
// the DC campaign flow (CampaignContext stores times as strings,
// pickers emit them as strings, validation needs numeric comparison).

/**
 * Convert 'HH:mm:ss' or 'HH:mm' to minutes since midnight.
 * Returns null for nullish input so callers can short-circuit.
 */
export default function toMinutes(hhmmss) {
  if (!hhmmss) return null;
  const [h, m] = String(hhmmss).split(':').map(Number);
  if (Number.isNaN(h) || Number.isNaN(m)) return null;
  return h * 60 + m;
}
